module.exports = __webpack_public_path__ + "static/media/creative-quarter-frontview.728018fa.jpg";